var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnstoppableDomains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3322 0.334961V8.05579L0.775391 17.1788L23.3322 0.334961Z",
    fill: "#00C9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1038 0V13.3189C19.1038 15.1802 18.3611 16.9652 17.0391 18.2813C15.717 19.5975 13.924 20.3369 12.0543 20.3369C10.1847 20.3369 8.39165 19.5975 7.06962 18.2813C5.74759 16.9652 5.00488 15.1802 5.00488 13.3189V7.70669L9.23383 5.38974V13.3189C9.19426 13.665 9.22854 14.0154 9.33445 14.3474C9.44041 14.6794 9.61555 14.9853 9.84853 15.2451C10.0815 15.5049 10.367 15.7128 10.6862 15.8552C11.0056 15.9976 11.3515 16.0712 11.7013 16.0712C12.0512 16.0712 12.3971 15.9976 12.7164 15.8552C13.0357 15.7128 13.3212 15.5049 13.5541 15.2451C13.7871 14.9853 13.9623 14.6794 14.0682 14.3474C14.1742 14.0154 14.2084 13.665 14.1688 13.3189V2.6878L19.1038 0Z",
    fill: "#0D67FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnstoppableDomains);
export default __webpack_public_path__ + "static/media/unstoppableDomains.73b5264ab9d0e09276a33cf124daede6.svg";
export { ForwardRef as ReactComponent };